import { ProductTier } from '@sparemin/api-sdk';

export interface WelcomeStepProps {
  title?: string;
  onNextClick?: (tier?: ProductTier) => void;
}

export enum WelcomeType {
  BASIC = 'BASIC',
  DEFAULT = 'DEFAULT',
  PRO = 'PRO',
  TRIAL = 'TRIAL',
  UNLIMITED = 'UNLIMITED',
}
